export default "__VITE_ASSET__DHw$R$zI__"